import { useMediaQuery } from '@material-ui/core';
export var ViewportTypes;
(function (ViewportTypes) {
    ViewportTypes["MOBILE"] = "MOBILE";
    ViewportTypes["COMPUTER"] = "COMPUTER";
})(ViewportTypes || (ViewportTypes = {}));
export const useViewportType = () => {
    const isMobile = useMediaQuery('(max-width: 768px), (max-device-width: 768px)');
    return isMobile ? ViewportTypes.MOBILE : ViewportTypes.COMPUTER;
};
